import usePageable from '@/composables/filters/usePageable';
import {ref} from 'vue';

export default function () {
  const pageable = usePageable();

  const filters = ref({
    barcodeId: {value: null},
    code: {value: null},
    lineId: {value: null},
    lineIds: {value: []},
    userId: {value: null},
    deleted: {value: null},
    stakeholderId: {value: null},
  });

  function getQueryParams(){
    getQueryParams(0)
  }

  function getQueryParams(sizeValue) {
    const params = (sizeValue != null && sizeValue > 0) ? pageable.getQueryParams(sizeValue): pageable.getQueryParams();
    return setQueryParams(params);
  }

  function setQueryParams(params){
    if (filters.value.barcodeId?.value) {
          params['barcodeId'] = filters.value.barcodeId.value;
        }

        if (filters.value.code?.value) {
          params['code'] = filters.value.code.value;
        }

        if (filters.value.lineId?.value) {
          params['lineId'] = filters.value.lineId.value;
        }

        if (filters.value.lineIds?.value && filters.value.lineIds?.value.length > 0) {
          params['lineIds'] = filters.value.lineIds.value.join(',');
        }

        if (filters.value.userId?.value) {
          params['userId'] = filters.value.userId.value;
        }

        if (filters.value.stakeholderId?.value) {
          params['stakeholderId'] = filters.value.stakeholderId.value;
        }

        if (filters.value.deleted?.value != null) {
          params['deleted'] = filters.value.deleted.value;
        }

        return params;
  }

  return {
    pageable,
    filters,
    getQueryParams,
  }
}


